<template>
  <!-- <a-locale-provider :locale="zh_CN"> -->
    <!-- <router-view /> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
    <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
  <!-- </a-locale-provider> -->
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
// import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "App",
  data() {
    return {
      // zh_CN,
    };
  },
};
</script>
